import dynamic from 'next/dynamic';
import css from './index.module.scss';
import A_ZA from './components/A_ZA';
import A from './components/A';
import { useGlobal } from '@/utils/useGlobal';

const PageConPc = dynamic(() => import('@/components/productRiver/river2/Details/indexDynamic'), {
    ssr: true,
});
export default function Details() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <div className={`rier2_details ${css.details}`}>
            {locale === 'za' ? <A_ZA /> : <A />}
            <PageConPc />
        </div>
    );
}
